const __WEBPACK_NAMESPACE_OBJECT__ = ReactDnDHTML5Backend;